import { DashboardMenu } from "../../data/menu"
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import changeUrl from "../../hoc/changeur";
import { config } from "../../data/config";
import ImageUploader from "../tools/uploaderImage"
import { useTranslation } from 'react-i18next';
import HeaderOfPage from "../tools/headerOfPage";

export default function RequestFroms() {
    const { t } = useTranslation();

    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Feature',
            url: '/dashboard/Feature'
        },
        {
            name: 'لیست درخواست ها',
            url: null
        },
    ]
    const reloadgame = () => {
        let x = key + 1;
        setKey(x);
    }
    const [key, setKey] = useState(1);

    return (
        <>
            <div className="bg-gray-50 min-h-screen p-4 md:p-6">
                <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="لیست درخواست ها"></HeaderOfPage>
                <div className="mt-6">
                    <ListOfForms key={key}></ListOfForms>
                </div>
            </div>
        </>
    )
}

function ListOfForms() {
    const { t } = useTranslation();

    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [name, setName] = useState<any>('');
    const [status, setStatus] = useState<any>('');
    const [email, setEmail] = useState<any>('');
    const [showitem, setShowItem] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [updating, setUpdating] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);

    const loaddata = async (page = 1) => {
        setLoading(true);
        try {
            let res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/requests?page=${page}&status=${status}&email=${email}&name=${name}`,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data.message;
            setList(mydata);
            setCurrentPage(page);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'خطا',
                text: error.response?.data?.message || 'خطا در بارگذاری اطلاعات',
            });
        } finally {
            setLoading(false);
        }
    }

    const changedata = async ({ id, status }: any) => {
        setUpdating(id);
        try {
            let res = await axios({
                method: 'put',
                url: config.url + '/v1/dashboard/requests/' + id,
                data: {
                    status: status
                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: t('Status changed successfully'),
                timer: 1500,
                showConfirmButton: false
            });

            loaddata(currentPage);
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error changing status'),
            });
        } finally {
            setUpdating(null);
        }
    }

    const deleted = async (id: any) => {
        Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this request!"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t('Yes, delete it'),
            cancelButtonText: t('Cancel')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    let res = await axios({
                        method: 'delete',
                        url: config.url + '/v1/dashboard/requests/' + id,
                        headers: {
                            Authorization: 'Bearer ' + cookie['token'],
                        }
                    })

                    Swal.fire({
                        icon: 'success',
                        title: t('Deleted'),
                        text: t('Request deleted successfully'),
                        timer: 1500,
                        showConfirmButton: false
                    });

                    loaddata(currentPage);
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: error.response?.data?.message || t('Error deleting request'),
                    });
                }
            }
        });
    }

    function toPersianDate(isoString: any) {
        function gregorianToJalali(gy: any, gm: any, gd: any) {
            var g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            var jy = (gy <= 1600) ? 0 : 979;
            gy -= (gy <= 1600) ? 621 : 1600;
            var gy2 = (gm > 2) ? (gy + 1) : gy;
            var days = (365 * gy) + Math.floor((gy2 + 3) / 4)
                - Math.floor((gy2 + 99) / 100)
                + Math.floor((gy2 + 399) / 400)
                - 80 + gd + g_d_m[gm - 1];
            jy += 33 * Math.floor(days / 12053);
            days %= 12053;
            jy += 4 * Math.floor(days / 1461);
            days %= 1461;
            if (days > 365) {
                jy += Math.floor((days - 1) / 365);
                days = (days - 1) % 365;
            }
            var jm = (days < 186) ? 1 + Math.floor(days / 31) : 7 + Math.floor((days - 186) / 30);
            var jd = 1 + ((days < 186) ? (days % 31) : ((days - 186) % 30));
            return [jy, jm, jd];
        }

        let d = new Date(isoString);
        let [jy, jm, jd] = gregorianToJalali(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate());
        return `${jy}/${jm.toString().padStart(2, '0')}/${jd.toString().padStart(2, '0')}`;
    }

    function getStatusBadge(status: number) {
        const statusMap: any = {
            1: { text: 'جدید', color: 'bg-blue-100 text-blue-800 border-blue-200' },
            2: { text: 'خوانده شده', color: 'bg-green-100 text-green-800 border-green-200' },
            3: { text: 'ریجکت شده', color: 'bg-red-100 text-red-800 border-red-200' },
        };
        return statusMap[status] || statusMap[1];
    }

    useEffect(() => {
        loaddata(1);
    }, []);

    if (loading && !list) {
        return (
            <div className="bg-white rounded-xl shadow p-8">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                </div>
                <p className="text-center mt-4 text-gray-600">در حال بارگذاری...</p>
            </div>
        );
    }

    return (
        <div className="space-y-6" dir="rtl">
            {/* Filters Card */}
            <div className="bg-white rounded-xl shadow-sm p-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">فیلتر و جستجو</h3>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            نام
                        </label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                            placeholder="جستجو بر اساس نام..."
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            ایمیل
                        </label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                            placeholder="جستجو بر اساس ایمیل..."
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            وضعیت
                        </label>
                        <select
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                        >
                            <option value="">همه وضعیت‌ها</option>
                            <option value="1">جدید</option>
                            <option value="2">خوانده شده</option>
                            <option value="3">ریجکت شده</option>
                        </select>
                    </div>
                    <div className="flex items-end">
                        <button
                            onClick={() => loaddata(1)}
                            className="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                        >
                            اعمال فیلتر
                        </button>
                    </div>
                </div>
            </div>

            {/* Stats Cards */}
            {list && (
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="bg-white rounded-xl shadow-sm p-6 border-r-4 border-blue-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">کل درخواست‌ها</p>
                                <p className="text-2xl font-bold text-gray-800 mt-1">{list.totalDocs || 0}</p>
                            </div>
                            <div className="bg-blue-100 p-3 rounded-lg">
                                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6 border-r-4 border-yellow-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">درخواست‌های جدید</p>
                                <p className="text-2xl font-bold text-gray-800 mt-1">
                                    {list.docs?.filter((item: any) => item.status === 1).length || 0}
                                </p>
                            </div>
                            <div className="bg-yellow-100 p-3 rounded-lg">
                                <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6 border-r-4 border-green-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">خوانده شده</p>
                                <p className="text-2xl font-bold text-gray-800 mt-1">
                                    {list.docs?.filter((item: any) => item.status === 2).length || 0}
                                </p>
                            </div>
                            <div className="bg-green-100 p-3 rounded-lg">
                                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white rounded-xl shadow-sm p-6 border-r-4 border-red-500">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-sm text-gray-600">ریجکت شده</p>
                                <p className="text-2xl font-bold text-gray-800 mt-1">
                                    {list.docs?.filter((item: any) => item.status === 3).length || 0}
                                </p>
                            </div>
                            <div className="bg-red-100 p-3 rounded-lg">
                                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Requests List */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    نام و نام خانوادگی
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    اطلاعات تماس
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    موضوع
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    وضعیت
                                </th>
                                <th scope="col" className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    تاریخ
                                </th>
                                <th scope="col" className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                                    عملیات
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {list && list.docs && list.docs.length > 0 ? (
                                list.docs.map((item: any, index: any) => {
                                    const statusBadge = getStatusBadge(parseInt(item.status));
                                    const isExpanded = showitem === index;
                                    
                                    return (
                                        <>
                                            <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center">
                                                        <div>
                                                            <div className="text-sm font-medium text-gray-900">
                                                                {item.name} {item.lastname}
                                                            </div>
                                                            {item.position && (
                                                                <div className="text-sm text-gray-500">{item.position}</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm text-gray-900">
                                                        <div className="flex items-center gap-2 mb-1">
                                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                            </svg>
                                                            <a href={`mailto:${item.email}`} className="text-blue-600 hover:text-blue-800" dir="ltr">
                                                                {item.email}
                                                            </a>
                                                        </div>
                                                        <div className="flex items-center gap-2">
                                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                            </svg>
                                                            <a href={`tel:${item.phone}`} className="text-blue-600 hover:text-blue-800">
                                                                {item.phone}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4">
                                                    <div className="text-sm text-gray-900">
                                                        {item.model === "ContactForm" && item.data?.subject ? (
                                                            <span className="font-medium">{item.data.subject}</span>
                                                        ) : item.model === "CollaborationForm" ? (
                                                            <span className="font-medium">درخواست همکاری</span>
                                                        ) : (
                                                            <span className="text-gray-400">-</span>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <select
                                                        value={item.status}
                                                        onChange={(e) => changedata({ id: item.id, status: e.target.value })}
                                                        disabled={updating === item.id}
                                                        className={`px-3 py-1.5 text-sm font-medium rounded-full border ${statusBadge.color} focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed`}
                                                    >
                                                        <option value={1}>جدید</option>
                                                        <option value={2}>خوانده شده</option>
                                                        <option value={3}>ریجکت شده</option>
                                                    </select>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                    {toPersianDate(item.createdAt)}
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                    <div className="flex items-center justify-center gap-2">
                                                        <button
                                                            onClick={() => setShowItem(isExpanded ? null : index)}
                                                            className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
                                                        >
                                                            {isExpanded ? (
                                                                <>
                                                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                                    </svg>
                                                                    بستن
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                                    </svg>
                                                                    مشاهده
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => deleted(item.id)}
                                                            className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors"
                                                        >
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            {isExpanded && (item.model === "ContactForm" || item.model === "CollaborationForm") && (
                                                <tr className="bg-gray-50">
                                                    <td colSpan={6} className="px-6 py-6">
                                                        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                                                            <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                                                                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                                </svg>
                                                                جزئیات درخواست
                                                            </h4>
                                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">نام</label>
                                                                    <p className="text-gray-900">{item.name}</p>
                                                                </div>
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">نام خانوادگی</label>
                                                                    <p className="text-gray-900">{item.lastname}</p>
                                                                </div>
                                                                {item.position && (
                                                                    <div>
                                                                        <label className="block text-sm font-medium text-gray-700 mb-1">سمت</label>
                                                                        <p className="text-gray-900">{item.position}</p>
                                                                    </div>
                                                                )}
                                                                {item.phone && (
                                                                    <div>
                                                                        <label className="block text-sm font-medium text-gray-700 mb-1">شماره تماس</label>
                                                                        <p className="text-gray-900">{item.phone}</p>
                                                                    </div>
                                                                )}
                                                                <div>
                                                                    <label className="block text-sm font-medium text-gray-700 mb-1">ایمیل</label>
                                                                    <p className="text-gray-900" dir="ltr">{item.email}</p>
                                                                </div>
                                                                {item.data?.subject && (
                                                                    <div>
                                                                        <label className="block text-sm font-medium text-gray-700 mb-1">موضوع</label>
                                                                        <p className="text-gray-900">{item.data.subject}</p>
                                                                    </div>
                                                                )}
                                                                {item.model === "CollaborationForm" && (
                                                                    <>
                                                                        {item.data?.gender && (
                                                                            <div>
                                                                                <label className="block text-sm font-medium text-gray-700 mb-1">جنسیت</label>
                                                                                <p className="text-gray-900">{item.data.gender}</p>
                                                                            </div>
                                                                        )}
                                                                        {item.data?.country && (
                                                                            <div>
                                                                                <label className="block text-sm font-medium text-gray-700 mb-1">کشور</label>
                                                                                <p className="text-gray-900">{item.data.country}</p>
                                                                            </div>
                                                                        )}
                                                                        {item.data?.audienceRegion && (
                                                                            <div>
                                                                                <label className="block text-sm font-medium text-gray-700 mb-1">منطقه مخاطبان</label>
                                                                                <p className="text-gray-900">{item.data.audienceRegion}</p>
                                                                            </div>
                                                                        )}
                                                                        {item.data?.socialMediaLink && (
                                                                            <div className="md:col-span-2">
                                                                                <label className="block text-sm font-medium text-gray-700 mb-1">لینک شبکه اجتماعی</label>
                                                                                <p className="text-gray-900">
                                                                                    <a href={item.data.socialMediaLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" dir="ltr">
                                                                                        {item.data.socialMediaLink}
                                                                                    </a>
                                                                                </p>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                            {item.data?.message && (
                                                                <div className="mt-6">
                                                                    <label className="block text-sm font-medium text-gray-700 mb-2">پیام</label>
                                                                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                                                        <div 
                                                                            className="text-gray-700 leading-relaxed"
                                                                            dangerouslySetInnerHTML={{ __html: item.data.message }}
                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={6} className="px-6 py-12 text-center">
                                        <div className="flex flex-col items-center">
                                            <svg className="w-16 h-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                            </svg>
                                            <p className="text-gray-500 text-lg">درخواستی یافت نشد</p>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {list && list.totalPages > 1 && (
                    <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
                        <div className="flex items-center justify-between">
                            <div className="text-sm text-gray-700">
                                نمایش {((list.page - 1) * list.limit) + 1} تا {Math.min(list.page * list.limit, list.totalDocs)} از {list.totalDocs} درخواست
                            </div>
                            <nav className="flex items-center gap-2">
                                {list.prevPage && (
                                    <button
                                        onClick={() => loaddata(list.page - 1)}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                    >
                                        قبلی
                                    </button>
                                )}
                                {Array.from({ length: list.totalPages }, (_, index) => index + 1).map((pageNum) => (
                                    <button
                                        key={pageNum}
                                        onClick={() => loaddata(pageNum)}
                                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                            list.page === pageNum
                                                ? 'bg-blue-600 text-white'
                                                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                                        }`}
                                    >
                                        {pageNum}
                                    </button>
                                ))}
                                {list.nextPage && (
                                    <button
                                        onClick={() => loaddata(list.page + 1)}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                                    >
                                        بعدی
                                    </button>
                                )}
                            </nav>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
